import $i from "~/i18n";
import router from "~/routes.js";

export const startCourse = async (context, payload) => {
  try {
    let body = { ...payload };
    var formData = new FormData();
    for (const key in body) {
      formData.append(key, body[key]);
    }
    let { data } = await axios.post("/course/form-save", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    if (data.state != 200) return;
    sessionStorage.setItem("course_id", data.course_id);
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
    if (payload.isMultiInst) {
      router.push("/dashboard/instructors");
    } else {
      router.push("/dashboard/sections");
    }
    window.sessionStorage.setItem("isMultiInst", payload.isMultiInst);
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/course-form/actions.js